export default __webpack_public_path__ + "static/media/cannoneer.681073c8.png";